// src/components/BitbucketSelectModal.tsx

import React from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import { BitbucketRepo } from '../types';

interface BitbucketSelectModalProps {
  show: boolean;
  onHide: () => void;
  bitbucketRepos: BitbucketRepo[];
  handleBitbucketUpdate: (repoSlug: string) => void;
  handleShowCreateBitbucketModal: () => void;
  bitbucketReposLoading: boolean; // <--- new prop
}

const BitbucketSelectModal: React.FC<BitbucketSelectModalProps> = ({
  show,
  onHide,
  bitbucketRepos,
  handleBitbucketUpdate,
  handleShowCreateBitbucketModal,
  bitbucketReposLoading
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select or Create Bitbucket Repo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bitbucketReposLoading ? (
          <div className="text-center">
            <Spinner animation="border" />
            <p>Loading Bitbucket Repos...</p>
          </div>
        ) : (
          <>
            <Form.Group controlId="bitbucketSelection">
              <Form.Label>Bitbucket Repo</Form.Label>
              <Form.Control
                as="select"
                onChange={(e) => handleBitbucketUpdate(e.target.value)}
              >
                <option value="">Choose a repo</option>
                {bitbucketRepos.map((repo) => (
                  <option key={repo.slug} value={repo.slug}>
                    {repo.slug}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
            <Button variant="success" onClick={handleShowCreateBitbucketModal}>
              Create New Repo
            </Button>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default BitbucketSelectModal;
